"use client";

import React from "react";
import styles from "./index.module.scss";
import Filter from "@/features/bridge-scanner/components/table/left-controls/filter";
import DateRangeFilter from "@/features/bridge-scanner/components/table/left-controls/date-range";

type Props = {
  resetTableIndex: () => void;
};

const LeftControls = ({ resetTableIndex }: Props) => {
  return (
    <div className={styles.leftControlsContainer}>
      <Filter resetTableIndex={resetTableIndex} />
      <DateRangeFilter resetTableIndex={resetTableIndex} />
    </div>
  );
};

export default LeftControls;
